import Service from 'src/setup/network';
import { Dispatch } from 'redux';
import {
  FETCH_DESIGNATION_FAILURE,
  FETCH_DESIGNATION_REQUEST,
  FETCH_DESIGNATION_SUCCESS,
  DesignationActionType,
} from '../types/designationTypes';
import { Designation } from 'src/types/model';

export const fetchDesignationRequest = (): DesignationActionType => ({
  type: FETCH_DESIGNATION_REQUEST,
});

export const fetchDesignationSuccess = (
  data: Designation[]
): DesignationActionType => ({
  type: FETCH_DESIGNATION_SUCCESS,
  payload: data,
});

export const fetchDesignationFailure = (
  error: string
): DesignationActionType => ({
  type: FETCH_DESIGNATION_FAILURE,
  payload: error,
});

export const fetchDesignation = () => {
  return async (dispatch: Dispatch<DesignationActionType>) => {
    dispatch(fetchDesignationRequest());
    try {
      const request = await Service.get('/designations');
      const data: Designation[] = request?.data?.data?.designations;
      dispatch(fetchDesignationSuccess(data));
    } catch (error: any) {
      dispatch(fetchDesignationFailure(error?.response?.data?.message));
      throw new Error('Failed to fetch employee');
    }
  };
};
